export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";